import BaseRestClient from "./baseClient";

export function getAppSettings() {
  return BaseRestClient.fetch("/api/v1/app/app-settings");
}
